import { render } from "./AnalyticsSkeleton.vue?vue&type=template&id=273d7c5b&scoped=true"
const script = {}

import "./AnalyticsSkeleton.vue?vue&type=style&index=0&id=273d7c5b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273d7c5b"]])

export default __exports__